// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1mPxL","description":"PatientConsentPreview_description__373s5"};